import { Attributes, NeoModel, Rules, ValueObject } from "@singularsystems/neo-core";

@NeoModel
export default class ExchangeRatesForDayExtractReportCriteria extends ValueObject {
    @Rules.Required()
    @Attributes.Date()
    public reportingDate: Date | null = null;
}